export const env = {
  client_id: import.meta.env.VITE_CLIENT_ID ?? "react_standalone_pos_spa",

  get clientId() {
    return this.client_id;
  },

  // ------------ Auth -------------
  authServer:
    import.meta.env.VITE_AUTH_SERVER ??
    "https://demo.account.softifybd.com",
  authApiBase:
    import.meta.env.VITE_AUTH_API_BASE ??
    "https://dev.ocelotgw.biznify.net/authorization/api",
  scope:
    import.meta.env.VITE_AUTH_SCOPE ??
    "openid profile email api.read offline_access",

  // ------------ API endpoints -------------
  posBaseUrl:
    import.meta.env.VITE_POS_BASE_URL ??
    "https://dev.ocelotgw.biznify.net/pos/api/v1",
  itemBaseUrl:
    import.meta.env.VITE_ITEM_BASE_URL ??
    "https://dev.ocelotgw.biznify.net/item/api/v1",
  salesBaseUrl:
    import.meta.env.VITE_SALE_BASE_URL ??
    "https://dev.ocelotgw.biznify.net/sale/api/v1",
  salesInvoiceBaseUrl:
    import.meta.env.VITE_SALES_INVOICE_BASE_URL ??
    "https://dev.ocelotgw.biznify.net/salesInvoice/api/v1",
  sharedConfigBaseUrl:
    import.meta.env.VITE_SHARED_CONFIG_BASE_URL ??
    "https://dev.sharedconfigservice.biznify.net/api/v1",
  discountBaseUrl:
    import.meta.env.VITE_DISCOUNT_BASE_URL ??
    "https://dev.ocelotgw.biznify.net/discount/api/v1",
  inventoryBaseUrl:
    import.meta.env.VITE_INVENTORY_BASE_URL ??
    "https://dev.ocelotgw.biznify.net/inventory/api/v1",
};
